import { z } from 'zod';

const zodPartySummarySchema = z
  .object({
    legalOrganization: z.object({ name: z.string().nullish() }).nullish(),
  })
  .nullish();

const zodDeliveryNoteSummaryAdminBodySchema = z.object({
  header: z
    .object({
      date: z.string().nullish(),
      id: z.string().or(z.number()).nullish(),
    })
    .nullish(),
  transaction: z
    .object({
      delivery: z
        .object({
          shipFrom: zodPartySummarySchema,
          shipTo: zodPartySummarySchema,
        })
        .nullish(),
    })
    .nullish(),
});

/**
 * The fields of an admin delivery note (asset main) that identify it, e.g. before it is deleted.
 * State values stay plain strings to accept historical values outside the declared enum set.
 */
export const zodDeliveryNoteSummaryAdminResponseSchema = z.object({
  assetState: z
    .object({ body: zodDeliveryNoteSummaryAdminBodySchema.nullish() })
    .nullish(),
  billedState: z.string().nullish(),
  id: z.uuid(),
  processState: z.string().nullish(),
});
